import React from "react";
import '../assets/css/search.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Home from "./Home"
import Search from "./Search"

export default function Example() {
    return (
        <Router>
            <Switch>
                <Route exact path="/">
                    <Home />
                </Route>
                <Route path="/search">
                    <Search />
                </Route>
            </Switch>
        </Router>
    );
}
